import { createFileRoute } from '@tanstack/react-router';

import { DealEditorPage } from '../features/demand/deals/components/DealEditorPage';

export const Route = createFileRoute('/demand/deals/edit/$dealId')({
  component: DealEditRoute,
});

function DealEditRoute() {
  const { dealId } = Route.useParams();
  return <DealEditorPage dealId={dealId} />;
}
